import styled, {css} from 'styled-components';

import {breakpoint, colors} from 'theme';

import {PillVariant} from '.';

export const Root = styled.div`
    display: flex;
    flex-flow: row wrap;
`;

export const Pill = styled.div<{isActive: boolean; variant: PillVariant}>`
    font-size: 12px;
    cursor: pointer;

    ${(p) =>
        p.variant === PillVariant.text &&
        css`
            padding: 0 15px 5px 15px;
            margin-bottom: 10px;

            &:not(:last-of-type) {
                margin-right: 10px;
            }

            @media (min-width: ${breakpoint.tablet}) {
                padding: 0 15px 15px 15px;

                &:not(:last-of-type) {
                    margin-right: 10px;
                }
            }
        `}
    
    ${(p) =>
        p.variant === PillVariant.text &&
        p.isActive &&
        css`
            border-bottom: 2px solid ${colors.brandPrimary};
            font-weight: 700;
        `}

    ${(p) =>
        p.variant === PillVariant.button &&
        css`
            color: ${colors.textMuted};
            background-color: ${colors.white};
            padding: 14px 27px;
            &:first-of-type {
                border-radius: 6px 0 0 6px;
            }
            &:last-of-type {
                border-radius: 0 6px 6px 0;
            }
            &:not(:last-of-type) {
                margin-right: 2px;
            }
        `}

    ${(p) =>
        p.variant === PillVariant.button &&
        p.isActive &&
        css`
            color: ${colors.black};
            font-weight: 500;
        `}
`;
